import React, { useEffect, useCallback } from 'react';
// import { connect } from 'react-redux';
// import { operations as incidentOperations } from '../../state/modules/incidents';
// import { operations as activityReportOperations } from '../../state/modules/activity-reports';
// import { selectors as incidentSelectors } from '../../state/modules/incidents';
// import { selectors as activityReportSelectors } from '../../state/modules/activity-reports';
// import { overlappingAttendancesByUserId } from '../../state/modules/attendances/selectors';
import { Alert, Badge } from '../ui-kit';
import { formatTimeHuman } from '../../utils/time';
import { isEmpty, debounce } from 'lodash';
import moment from 'moment';

const OverlappingAttendancesWarning = ({
  startTime,
  endTime,
  activity,
  userIds,
  activityOverlappingAttendances,
  fetchIncidents,
  fetchActivities,
  groupIds
}) => {
  const fetchIncidentsDebounced = useCallback(
    debounce(params => {
      fetchIncidents(params);
    }, 1000),
    []
  );
  const fetchActivitiesDebounced = useCallback(
    debounce(params => {
      fetchActivities(params);
    }, 1000),
    []
  );

  useEffect(() => {
    // If the difference between the start and end time is too large
    // don't fetch overlapping attendances, or it will get too slow
    if (moment(endTime).diff(startTime, 'days') > 7) return;

    fetchIncidentsDebounced({
      params: {
        start_time: startTime,
        end_time: endTime,
        include_open_ended: false,
        per_page: 50,
        group_ids: groupIds,
        in_hierarchy: true
      },
      forceFetch: true,
      except: [activity.id]
    });
    fetchActivitiesDebounced({
      params: {
        start_time: startTime,
        end_time: endTime,
        include_open_ended: false,
        per_page: 50,
        group_ids: groupIds,
        in_hierarchy: true
      },
      forceFetch: true,
      except: [activity.id]
    });
  }, [startTime, endTime]);

  const overlappingAttendances = activityOverlappingAttendances(activity.id, userIds);

  // If there are no overlapping attendances or no relevant users supplied
  // don't render the warning
  if (isEmpty(overlappingAttendances) || isEmpty(userIds)) return null;

  return (
    <Alert variant="danger">
      <p>{I18n.t('activity_reports.overlapping_attendances')}:</p>
      <ul>
        {overlappingAttendances.map(attendance => {
          const { activityId, activity } = attendance;

          const url = `/activity_reports/${activityId}`;

          const label = activity.type ? I18n.t(`activerecord.models.incidents/${activity.type}.one`) : null;

          return (
            <li key={attendance.id}>
              {attendance.user?.name && <span>{attendance.user?.name}: </span>}
              {label && <Badge>{label}</Badge>}{' '}
              <a href={url}>
                {activity.body || activity.title || activity.id}{' '}
                {formatTimeHuman(attendance.start_time, { shorten: false })} -{' '}
                {formatTimeHuman(attendance.end_time, { shorten: false })}
              </a>
            </li>
          );
        })}
      </ul>
    </Alert>
  );
};

// TODO: the following cannot be done because the related tests will fail.
// In order to use connect this component directly to redux, we need to refactor the tests.
// In order to refactor the tests, we need Node.js 18
// const mapStateToProps = state => ({
//   incidentsById: incidentSelectors.byId(state),
//   activitiesById: activityReportSelectors.byId(state),
//   overlappingAttendancesByUserId: overlappingAttendancesByUserId(state)
// });

// const mapDispatchToProps = {
//   fetchActivities: activityReportOperations.fetch,
//   fetchIncidents: incidentOperations.fetch
// };

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(OverlappingAttendancesWarning);
export default OverlappingAttendancesWarning;
